module.exports = __webpack_public_path__ + "img/balloon.b562db1b.png";